<template>
	<div class="home-page" @click="closeAllBox" @contextmenu="closeAllBox">
		<div class="app-container" :class="{ fullscreen: configStore.fullScreen, electron: configStore.electronMode }">
			<div class="navi-bar">
				<div class="navi-bar-box">
					<div class="top">
						<div class="avater" @click="showUserProfile">
							<head-image :name="mine.nickName" :size="42" :url="mine.headImageThumb" >
							</head-image>
						</div>
						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'">
								<div class="menu-item">
									<span class="icon iconfont icon-chat"></span>
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'">
								<div class="menu-item">
									<span class="icon iconfont icon-friend"></span>
									<div v-show="recvCount > 0" class="unread-text">{{ recvCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/group'">
								<div class="menu-item">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/setting'">
								<div class="menu-item">
									<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
								</div>
							</router-link>
						</div>
					</div>

					<div class="bottom">
						<div v-if="!configStore.electronMode" class="bottom-item" @click="onSwtichFullScreen">
							<i class="el-icon-full-screen"></i>
						</div>
						<div class="bottom-item" @click="onExit()" title="退出">
							<span class="icon iconfont icon-exit"></span>
						</div>
					</div>
				</div>
			</div>
			<div class="content-box">
				<router-view></router-view>
			</div>
			<user-info ref="userInfo"></user-info>
			<group-info ref="groupInfo"></group-info>
			<full-image ref="fullImage"></full-image>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
			<user-profile-card ref="userProfileCard"></user-profile-card>
		</div>
	</div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import UserInfo from '../components/common/UserInfo.vue';
import GroupInfo from '../components/group/GroupInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import UserProfileCard from '../components/common/UserProfileCard.vue';
import { initYunxinFromSavedLoginInfo } from '../api/loginHelper.js';
import { normalizeSdkMessageToLegacyAsync } from '../api/yunxinIM.js';
import { getCachedImageUrl } from '../utils/imageCache.js';

const HOME_WINDOW_SIZE_KEY = 'homeWindowSize';
const HOME_WINDOW_MIN_WIDTH = 970;
const HOME_WINDOW_MIN_HEIGHT = 660;
const HOME_WINDOW_DEFAULT_WIDTH = 1080;
const HOME_WINDOW_DEFAULT_HEIGHT = 768;

export default {
	components: {
		HeadImage,
		UserInfo,
		GroupInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo,
		UserProfileCard
	},
	data() {
		return {
			audio: false,
			lastPlayAudioTime: new Date().getTime() - 1000,
			reconnecting: false,
			notification: null,
			privateMessagesBuffer: [],
			groupMessagesBuffer: [],
			systemMessagesBuffer: [],
			yunxinUnsubscribers: [],
			windowResizeTimer: null
		}
	},
	methods: {
		isIdLikeName(name, accountId = '') {
			const value = String(name || '');
			if (!value) return true;
			if (accountId && value === String(accountId)) return true;
			return /^[a-f0-9]{24,}$/i.test(value) || /^[0-9]{8,}$/.test(value);
		},
		async init() {
			this.$eventBus.$on('exit', () => {
				// 退出登陆
				this.onExit();
			});
			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话
				this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话
				this.$refs.rtcGroupVideo.open(rctInfo);
			});
			this.$eventBus.$on('openUserInfo', (user, pos) => {
				// 打开用户卡片
				this.$refs.userInfo.open(user, pos);
			});
			this.$eventBus.$on('openGroupInfo', (group, pos) => {
				// 打开群卡片
				this.$refs.groupInfo.open(group, pos);
			});
			this.$eventBus.$on('openFullImage', async url => {
				// 图片大图
				this.$refs.fullImage.open(await getCachedImageUrl(url));
			});
			this.configStore.setAppInit(false)
			const yunxinReady = await initYunxinFromSavedLoginInfo();
			if (yunxinReady) {
				this.bindYunxinEvents();
			} else {
				console.warn('[Home] 未获取到云信登录信息，跳过云信事件监听');
			}
			this.loadStore().then(() => {
				this.flushYunxinMessageBuffer();
				this.configStore.setAppInit(true);
			}).catch(e => {
				console.log(e)
				this.$message.error("初始化失败");
				this.onExit();
			})
		},
		bindYunxinEvents() {
			this.clearYunxinEvents();
			this.yunxinUnsubscribers = [
				this.$yunxinIM.on('newMessage', message => this.handleYunxinMessage(message)),
				this.$yunxinIM.on('syncMessages', messages => this.handleYunxinMessages(messages)),
				this.$yunxinIM.on('conversationDeleted', conversationIds => this.handleConversationDeleted(conversationIds)),
				this.$yunxinIM.on('customNotification', notifications => this.handleYunxinCustomNotifications(notifications)),
				this.$yunxinIM.on('messageRevokeNotifications', messages => this.handleYunxinRevokeMessages(messages)),
				this.$yunxinIM.on('p2pMessageReadReceipt', receipts => this.handleP2PMessageReadReceipt(receipts)),
				this.$yunxinIM.on('teamMessageReadReceipt', receipts => this.handleTeamMessageReadReceipt(receipts)),
				this.$yunxinIM.on('friendAddApplication', request => this.friendStore.addRequest(request)),
				this.$yunxinIM.on('friendAddRejected', request => this.friendStore.removeRequestByAccounts(request.sendId, request.recvId)),
				this.$yunxinIM.on('friendAdded', friend => {
					this.friendStore.addFriend(friend);
					this.friendStore.removeRequestByAccounts(friend.id, this.mineAccount);
					this.friendStore.removeRequestByAccounts(this.mineAccount, friend.id);
				}),
				this.$yunxinIM.on('friendDeleted', ({ accountId }) => this.friendStore.removeFriend(accountId)),
				this.$yunxinIM.on('friendInfoChanged', friend => this.friendStore.updateFriend(friend)),
				this.$yunxinIM.on('userStatusChanged', statuses => this.handleUserStatusChanged(statuses)),
				this.$yunxinIM.on('teamJoinActionInfo', actionInfo => this.handleTeamJoinActionInfo(actionInfo)),
				this.$yunxinIM.on('teamJoined', team => this.handleTeamJoined(team)),
				this.$yunxinIM.on('teamLeft', ({ team }) => this.handleTeamLeft(team)),
				this.$yunxinIM.on('teamDismissed', team => this.handleTeamLeft(team)),
				this.$yunxinIM.on('teamInfoUpdated', team => this.handleTeamInfoUpdated(team)),
				this.$yunxinIM.on('kickedOffline', event => {
					const reasonDesc = event?.reasonDesc || '';
					const message = reasonDesc
						? `账号违反规定被封禁，原因：${reasonDesc}`
						: '账号违反规定被封禁';
					this.$alert(message, "强制下线通知", {
						confirmButtonText: '确定',
						callback: () => this.onExit()
					});
				}),
				this.$yunxinIM.on('disconnected', error => {
					console.warn('[Home] 云信 SDK 连接断开，SDK 将自动重连:', error);
					this.configStore.setAppInit(false);
				}),
				this.$yunxinIM.on('loginStatus', status => {
					if (status === 1) {
						this.reconnecting = false;
						this.configStore.setAppInit(true);
					}
				})
			];
		},
		clearYunxinEvents() {
			this.yunxinUnsubscribers.forEach(unsubscribe => unsubscribe && unsubscribe());
			this.yunxinUnsubscribers = [];
		},
		handleUserStatusChanged(statuses = []) {
			statuses.forEach(status => this.friendStore.updateOnlineStatus(status));
		},
		handleYunxinMessages(messages = []) {
			messages.forEach(message => this.handleYunxinMessage(message));
		},
		handleYunxinRevokeMessages(messages = []) {
			messages.forEach(msgInfo => {
				if (msgInfo.chatType === 'GROUP') {
					this.dispatchGroupMessage(msgInfo);
				} else {
					this.dispatchPrivateMessage(msgInfo);
				}
			});
		},
		handleP2PMessageReadReceipt(receipts = []) {
			receipts.forEach(receipt => {
				const friendId = receipt.friendId || receipt.accountId || receipt.from ||
					this.$yunxinIM.parseConversationTargetId(receipt.conversationId);
				this.chatStore.readedMessageByTime({
					friendId,
					timestamp: receipt.timestamp
				});
			});
		},
		handleTeamMessageReadReceipt(receipts = []) {
			receipts.forEach(receipt => {
				const groupId = this.$yunxinIM.parseConversationTargetId(receipt.conversationId);
				if (!groupId) {
					return;
				}
				const chatInfo = { type: 'GROUP', targetId: groupId };
				this.chatStore.updateMessage({
					id: receipt.messageServerId || receipt.messageClientId,
					tmpId: receipt.messageClientId,
					selfSend: true,
					readedCount: receipt.readCount,
					unreadCount: receipt.unreadCount,
					receiptOk: Number(receipt.unreadCount || 0) === 0
				}, chatInfo);
			});
		},
		handleConversationDeleted(conversationIds = []) {
			const idSet = new Set((conversationIds || []).filter(Boolean).map(id => String(id)));
			if (!idSet.size) {
				return;
			}
			this.chatStore.removeChatsByConversationIds(conversationIds);
			const keepMessage = message => !idSet.has(String(message.conversationId || message.sourceMessage?.conversationId || ''));
			this.privateMessagesBuffer = this.privateMessagesBuffer.filter(keepMessage);
			this.groupMessagesBuffer = this.groupMessagesBuffer.filter(keepMessage);
		},
		handleYunxinCustomNotifications(notifications = []) {
			notifications.forEach(notification => {
				let payload = {};
				try {
					payload = typeof notification.content === 'string' ? JSON.parse(notification.content) : notification.content;
				} catch (error) {
					return;
				}
				const msg = {
					id: payload.id || `${notification.senderId}_${notification.timestamp || Date.now()}`,
					type: Number(payload.type),
					content: payload.content || '',
					sendId: payload.sendId || notification.senderId,
					recvId: payload.recvId || notification.receiverId,
					sendTime: notification.timestamp || payload.timestamp || Date.now(),
					selfSend: this.isMineAccount(payload.sendId || notification.senderId)
				};
				if (this.$msgType.isRtcPrivate(msg.type)) {
					this.$nextTick(() => this.$refs.rtcPrivateVideo.onRTCMessage(msg));
				}
			});
		},
		async handleYunxinMessage(message) {
			const msgInfo = await normalizeSdkMessageToLegacyAsync(message);
			if (msgInfo.chatType === 'GROUP') {
				this.dispatchGroupMessage(msgInfo);
			} else if (msgInfo.chatType === 'SYSTEM') {
				this.dispatchSystemMessage(msgInfo);
			} else {
				this.dispatchPrivateMessage(msgInfo);
			}
		},
		async handleTeamJoinActionInfo(actionInfo = {}) {
			const actionType = Number(actionInfo.actionType);
			const actionStatus = Number(actionInfo.actionStatus || 0);
			if (actionType !== 2 || actionStatus !== 0) {
				return;
			}
			let team = null;
			try {
				team = await this.$yunxinIM.getTeamInfo(actionInfo.teamId, actionInfo.teamType || 1);
			} catch (error) {
				console.warn('[Home] 获取入群邀请群信息失败:', error);
			}
			const groupName = team?.name || actionInfo.teamName || `群聊 ${actionInfo.teamId}`;
			const operatorName = await this.getAccountDisplayName(actionInfo.operatorAccountId);
			const body = `${operatorName}邀请你加入${groupName}${actionInfo.postscript ? `：${actionInfo.postscript}` : ''}`;
			this.groupStore.addTeamNotice({
				...actionInfo,
				teamName: groupName,
				teamAvatar: team?.avatar || '',
				operatorName,
				read: false,
				sourceActionInfo: actionInfo
			});
			this.playAudioTip();
			this.$notify({
				title: '入群邀请',
				message: body,
				type: 'info',
				duration: 6000
			});
			this.showSimpleNotification('入群邀请', body, team?.avatar || 'logo.ico');
		},
		async handleTeamJoined(team = {}) {
			const group = await this.buildSdkGroupFromTeam(team);
			if (!group.id) {
				return;
			}
			if (this.groupStore.findGroup(group.id)) {
				this.groupStore.updateGroup(group);
			} else {
				this.groupStore.addGroup(group);
			}
			this.$message.success(`已加入群聊：${group.showGroupName}`);
		},
		handleTeamLeft(team = {}) {
			const teamId = team.teamId || team.id;
			if (teamId) {
				if (this.groupStore.findGroup(teamId)) {
					this.groupStore.removeGroup(teamId);
				}
				this.chatStore.removeGroupChat(teamId);
			}
		},
		async handleTeamInfoUpdated(team = {}) {
			const group = await this.buildSdkGroupFromTeam(team);
			if (group.id && this.groupStore.findGroup(group.id)) {
				this.groupStore.updateGroup(group);
				this.chatStore.updateChatFromGroup(group);
			}
		},
		dispatchPrivateMessage(msgInfo) {
			if (!this.configStore.appInit || this.chatStore.loading) {
				this.privateMessagesBuffer.push(msgInfo);
			} else {
				this.handlePrivateMessage(msgInfo);
			}
		},
		dispatchGroupMessage(msgInfo) {
			if (!this.configStore.appInit || this.chatStore.loading) {
				this.groupMessagesBuffer.push(msgInfo);
			} else {
				this.handleGroupMessage(msgInfo);
			}
		},
		dispatchSystemMessage(msgInfo) {
			if (!this.configStore.appInit || this.chatStore.loading) {
				this.systemMessagesBuffer.push(msgInfo);
			} else {
				this.handleSystemMessage(msgInfo);
			}
		},
		flushYunxinMessageBuffer() {
			this.privateMessagesBuffer.forEach(m => this.handlePrivateMessage(m, true, { skipUnreadCount: true }));
			this.groupMessagesBuffer.forEach(m => this.handleGroupMessage(m, true, { skipUnreadCount: true }));
			this.systemMessagesBuffer.forEach(m => this.handleSystemMessage(m));
			this.privateMessagesBuffer = [];
			this.groupMessagesBuffer = [];
			this.systemMessagesBuffer = [];
		},
		reconnectWs() {
			// 记录标志
			this.reconnecting = true;
			// 云信 SDK 自带重连，这里仅在需要时重新加载基础资料并恢复监听
			this.userStore.loadUser().then(() => {
				this.$message.error("连接断开，正在尝试重新连接...");
				return initYunxinFromSavedLoginInfo();
			}).then(() => {
				this.reconnecting = false;
				this.configStore.setAppInit(true);
			}).catch(() => {
				// 10s后重试
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			// 重连成功
			this.reconnecting = false;
			// 重新加载群和好友
			const promises = [];
			promises.push(this.friendStore.loadFriend());
			promises.push(this.groupStore.loadGroup());
			Promise.all(promises).then(() => {
				// 加载离线消息
				this.pullOfflineMessage();
				this.configStore.setAppInit(true);
				this.$message.success("重新连接成功");
			}).catch(() => {
				this.$message.error("初始化失败");
				this.onExit();
			})
		},
		loadStore() {
			return this.userStore.loadUser().then(() => {
				return Promise.all([
					this.friendStore.loadFriend(),
					this.groupStore.loadGroup(),
					this.configStore.loadConfig()
				]).then(() => this.chatStore.loadChat());
			})
		},
		unloadStore() {
			this.friendStore.clear();
			this.groupStore.clear();
			this.chatStore.clear();
			this.userStore.clear();
		},
		pullOfflineMessage() {
			this.chatStore.setLoading(true);
			// 离线消息由云信云端会话/消息服务承载，这里不再拉取自有后端离线消息，避免重建已删除会话。
			this.privateMessagesBuffer.forEach(m => this.handlePrivateMessage(m, true, { skipUnreadCount: true }));
			this.groupMessagesBuffer.forEach(m => this.handleGroupMessage(m, true, { skipUnreadCount: true }));
			this.systemMessagesBuffer.forEach(m => this.handleSystemMessage(m));
			this.privateMessagesBuffer = [];
			this.groupMessagesBuffer = [];
			this.systemMessagesBuffer = [];
			this.chatStore.setLoading(false);
			this.chatStore.refreshChats();
		},
		pullPrivateOfflineMessage(minId) {
			return this.$http({
				url: "/message/private/loadOfflineMessage?minId=" + minId,
				method: 'GET'
			})
		},
		pullGroupOfflineMessage(minId) {
			return this.$http({
				url: "/message/group/loadOfflineMessage?minId=" + minId,
				method: 'GET'
			})
		},
		pullSystemOfflineMessage(minSeqNo) {
			return this.$http({
				url: "/message/system/loadOfflineMessage?minSeqNo=" + minSeqNo,
				method: 'GET'
			})
		},
		isSelfMessageSender(sendId) {
			return [
				this.mine.id,
				this.mine.accountId,
				this.mine.imAccid,
				this.$yunxinIM.currentAccount
			].filter(Boolean).map(item => String(item)).includes(String(sendId));
		},
		isMineAccount(accountId) {
			return [
				this.mine.id,
				this.mine.accountId,
				this.mine.imAccid,
				this.$yunxinIM.currentAccount
			].filter(Boolean).map(item => String(item)).includes(String(accountId));
		},
		handlePrivateMessage(msg, strictCloud = false, options = {}) {
			// 标记这条消息是不是自己发的
			msg.selfSend = this.isSelfMessageSender(msg.sendId);
			// 好友id
			let friendId = msg.selfSend ? msg.recvId : msg.sendId;
			// 会话信息
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friendId,
				conversationId: msg.conversationId || msg.sourceMessage?.conversationId
			}
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount(chatInfo)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				const readTime = Number(msg.timestamp || msg.readTime || msg.sendTime || 0);
				if (readTime) {
					this.chatStore.readedMessageByTime({
						friendId: msg.sendId,
						timestamp: readTime
					})
				} else {
					this.chatStore.readedMessage({
						friendId: msg.sendId,
						maxId: msg.maxId
					})
				}
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.chatStore.recallMessage(msg, chatInfo)
				return;
			}
			// 好友申请
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPLY) {
				this.friendStore.addRequest(JSON.parse(msg.content))
				return;
			}
			// 好友申请被同意、拒绝、撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPROVE
				|| msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_REJECT
				|| msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_RECALL) {
				this.friendStore.removeRequest(JSON.parse(msg.content).id)
				return;
			}
			// 新增好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.friendStore.addFriend(JSON.parse(msg.content));
				return;
			}
			// 删除好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.friendStore.removeFriend(friendId);
				return;
			}
			// 好友在线状态
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
				this.friendStore.updateOnlineStatus(JSON.parse(msg.content));
				return;
			}
			// 对好友设置免打扰
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
				this.friendStore.setDnd(friendId, JSON.parse(msg.content));
				this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 对好友进行会话置顶
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_TOP) {
				this.friendStore.setTop(friendId, JSON.parse(msg.content));
				this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 单人webrtc 信令
			if (this.$msgType.isRtcPrivate(msg.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(msg)
				return;
			}
			// 消息插入
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let friend = this.loadFriendInfo(friendId);
				this.insertPrivateMessage(friend, msg, strictCloud, options);
			}
		},
		insertPrivateMessage(friend, msg, strictCloud = false, options = {}) {
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friend.id,
				conversationId: msg.conversationId || msg.sourceMessage?.conversationId,
				showName: friend.showNickName,
				headImage: friend.headImage,
				companyName: friend.companyName,
				isDnd: friend.isDnd,
				isTop: friend.isTop
			};
			// 打开会话
			const chat = this.chatStore.openChat(chatInfo, { syncCloud: false, strictCloud });
			if (!chat) {
				return;
			}
			// 插入消息
			this.chatStore.insertMessage(msg, chatInfo, options);
			if (!friend.isDnd && !this.chatStore.loading &&
				!msg.selfSend && this.$msgType.isNormal(msg.type)
				&& msg.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 消息提醒
				this.showNotification(chat, friend.showNickName, friend.headImage)
			}
		},
		handleGroupMessage(msg, strictCloud = false, options = {}) {
			// 标记这条消息是不是自己发的
			msg.selfSend = this.isSelfMessageSender(msg.sendId);
			// 发送用户昵称优先显示好友备注的名字
			if (msg.sendId) {
				let f = this.friendStore.findFriend(msg.sendId);
				if (f && !f.deleted && f.remarkNickName) {
					msg.sendNickName = f.remarkNickName;
				} else if (this.isIdLikeName(msg.sendNickName, msg.sendId)) {
					msg.sendNickName = f?.showNickName || f?.nickName || '';
				}
			}
			let chatInfo = {
				type: 'GROUP',
				targetId: msg.groupId,
				conversationId: msg.conversationId || msg.sourceMessage?.conversationId
			}
			// 消息已读处理
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				this.chatStore.resetUnreadCount(chatInfo)
				this.chatStore.resetAtMessage(chatInfo)
				return;
			}
			// 消息回执处理
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				let msgInfo = {
					id: msg.id,
					groupId: msg.groupId,
					readedCount: msg.readedCount,
					receiptOk: msg.receiptOk
				};
				this.chatStore.updateMessage(msgInfo, chatInfo)
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.chatStore.recallMessage(msg, chatInfo)
				return;
			}
			// 新增群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				this.groupStore.addGroup(JSON.parse(msg.content));
				return;
			}
			// 删除群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.groupStore.removeGroup(msg.groupId);
				return;
			}
			// 群消息置顶
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP_MESSAGE) {
				let topMessage = msg.content ? JSON.parse(msg.content) : null;
				this.groupStore.updateTopMessage(msg.groupId, topMessage);
				return;
			}
			// 对群设置免打扰
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
				this.groupStore.setDnd(msg.groupId, JSON.parse(msg.content));
				this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 群全体禁言
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_ALL_MUTED) {
				this.groupStore.setAllMuted(msg.groupId, JSON.parse(msg.content));
				return;
			}
			// 被禁言
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_MUTED) {
				this.groupStore.setMuted(msg.groupId, JSON.parse(msg.content));
				return;
			}
			// 对好友进行会话置顶
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP) {
				this.groupStore.setTop(msg.groupId, JSON.parse(msg.content));
				this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
				return;
			}
			// 群视频信令
			if (this.$msgType.isRtcGroup(msg.type)) {
				this.$nextTick(() => {
					this.$refs.rtcGroupVideo.onRTCMessage(msg);
				})
				return;
			}
			// 插入群聊消息
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let group = this.loadGroupInfo(msg.groupId);
				this.insertGroupMessage(group, msg, strictCloud, options);
			}
		},
		insertGroupMessage(group, msg, strictCloud = false, options = {}) {
			let chatInfo = {
				type: 'GROUP',
				targetId: group.id,
				conversationId: msg.conversationId || msg.sourceMessage?.conversationId,
				showName: group.showGroupName,
				headImage: group.headImageThumb,
				isDnd: group.isDnd,
				isTop: group.isTop
			};
			// 打开会话
			const chat = this.chatStore.openChat(chatInfo, { syncCloud: false, strictCloud });
			if (!chat) {
				return;
			}
			// 插入消息
			this.chatStore.insertMessage(msg, chatInfo, options);
			// 提示音和消息提醒
			if (!group.isDnd && !msg.selfSend && !this.chatStore.loading && this.$msgType.isNormal(msg.type)
				&& msg.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 消息提醒
				this.showNotification(chat, group.showGroupName, group.headImageThumb)
			}
		},
		handleSystemMessage(msg) {
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount({
					type: 'SYSTEM',
					targetId: 0
				})
				return;
			}
			// 用户被封禁
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$yunxinIM.logout();
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			// 用户账户注销
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_UNREG) {
				this.$yunxinIM.logout();
				this.$alert("您的账号已注销", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			// 插入消息
			this.insertSystemMessage(msg);
		},
		insertSystemMessage(msg) {
			let headImage = require('@/assets/image/chat_system.png')
			let chatInfo = {
				type: 'SYSTEM',
				targetId: 0,
				showName: "系统通知",
				headImage: headImage
			};
			// 打开会话
			this.chatStore.openChat(chatInfo);
			// 插入消息
			this.chatStore.insertMessage(msg, chatInfo);
		},
		onSwtichFullScreen() {
			this.configStore.setFullScreen(!this.configStore.fullScreen);
		},
			onExit() {
			this.unloadStore();
			this.configStore.setAppInit(false);
			this.clearYunxinEvents();
			sessionStorage.removeItem("accessToken");
			this.$yunxinIM.logout();
			localStorage.setItem("isAutoLogin", false)
			this.$router.push("/login");
		},
		closeAllBox() {
			this.$refs.groupInfo.close();
			this.$refs.userInfo.close();
		},
		playAudioTip() {
			// 播放间隔必须大于1s
			let interval = new Date().getTime() - this.lastPlayAudioTime;
			if (this.mine.isAudioTip && interval > 1000) {
				if (!this.audio) {
					this.audio = new Audio();
					this.audio.src = require(`@/assets/audio/tip.mp3`);
				}
				this.lastPlayAudioTime = new Date().getTime();
				this.audio.play();
			}
		},
		showNotification(chat, title, icon) {
			// 消息提醒
			if (window.Notification && window.electronAPI) {
				// 当窗口失去焦点，则弹出通知消息
				window.electronAPI.invoke("isFocused").then(foucus => {
					if (!foucus) {
						this.notification && this.notification.close();
						let iconPath = icon ? icon : 'logo.ico';
						this.notification = new Notification(title, {
							body: chat.lastContent,
							icon: iconPath
						})
						// 点击通知消息，激活聊天会话
						this.notification.onclick = () => {
							this.chatStore.openChat(chat);
							this.chatStore.setActiveChat(chat);
							this.$router.push("/home/chat");
							// 唤醒在后台的客户端
							window.electronAPI.sendEvent("show");
						}
					}
				})
			}
		},
		showSimpleNotification(title, body, icon) {
			if (window.Notification && window.electronAPI) {
				window.electronAPI.invoke("isFocused").then(foucus => {
					if (!foucus) {
						this.notification && this.notification.close();
						this.notification = new Notification(title, {
							body,
							icon: icon || 'logo.ico'
						});
						this.notification.onclick = () => {
							this.$router.push("/home/group");
							window.electronAPI.sendEvent("show");
						};
					}
				})
			}
		},
		async getAccountDisplayName(accountId) {
			if (!accountId) {
				return '有人';
			}
			const friend = this.friendStore.findFriend(accountId);
			if (friend) {
				return friend.showNickName || friend.remarkNickName || friend.nickName || accountId;
			}
			const profiles = await this.$yunxinIM.getUserProfiles([accountId]).catch(() => []);
			const profile = profiles && profiles[0];
			return profile?.nickName || profile?.name || accountId;
		},
		parseTeamExtension(team = {}) {
			const rawExtension = team.serverExtension || team.ext || '';
			if (!rawExtension) {
				return {};
			}
			try {
				return typeof rawExtension === 'string' ? JSON.parse(rawExtension) : rawExtension;
			} catch (error) {
				console.warn('[Home] 解析群扩展字段失败:', error);
				return {};
			}
		},
		buildCurrentSdkMember() {
			const accountId = this.mine.imAccid || this.mine.accountId || this.mine.id || this.$yunxinIM.currentAccount;
			return {
				userId: accountId,
				nickName: this.mine.nickName || accountId,
				showNickName: this.mine.nickName || accountId,
				headImage: this.mine.headImageThumb || this.mine.headImage || '',
				online: true,
				isManager: false,
				isMuted: false,
				quit: false,
				version: 0
			};
		},
		async buildSdkGroupFromTeam(team = {}) {
			const teamId = team.teamId || team.id;
			const teamType = team.teamType || team.type || 1;
			const groupExt = this.parseTeamExtension(team);
			const oldGroup = this.groupStore.findGroup(teamId) || {};
			const members = teamId ? await this.$yunxinIM.getTeamMemberList(teamId, teamType).catch(() => []) : [];
			const normalizedMembers = members.length ? members.map(member => {
				const accountId = String(member.accountId || member.teamMemberAccountId || member.memberAccountId || '');
				const role = member.memberRole ?? member.teamMemberRole ?? member.role ?? 0;
				const numericRole = Number(role);
				return {
					userId: accountId,
					role: numericRole,
					nickName: member.teamNick || member.nickName || accountId,
					showNickName: member.teamNick || member.nickName || accountId,
					headImage: member.avatar || '',
					online: false,
					isManager: numericRole === 2 || String(role).toLowerCase().includes('manager'),
					isMuted: !!(member.chatBanned || member.isMuted),
					quit: false,
					version: Number(member.updateTime || member.createTime || 0)
				};
			}) : (oldGroup.members && oldGroup.members.length ? oldGroup.members : [this.buildCurrentSdkMember()]);
			const groupName = team.name || oldGroup.name || `群聊 ${teamId || ''}`;
			const chatBannedMode = Number(team.chatBannedMode ?? team.teamChatBannedMode ?? 0);
			const teamMemberCount = Number(team.memberCount);
			const memberCount = Number.isFinite(teamMemberCount) ? teamMemberCount : normalizedMembers.length;
			return {
				id: teamId,
				teamType,
				name: groupName,
				showGroupName: oldGroup.remarkGroupName || groupName,
				remarkGroupName: oldGroup.remarkGroupName || '',
				headImage: team.avatar || oldGroup.headImage || '',
				headImageThumb: team.avatar || oldGroup.headImageThumb || '',
				notice: team.announcement || '',
				intro: team.intro || '',
				serverExtension: team.serverExtension || team.ext || '',
				ownerId: team.ownerAccountId || team.ownerId || '',
				members: normalizedMembers,
				memberCount,
				quit: false,
				isAllMuted: chatBannedMode === 1 || chatBannedMode === 3,
				isDnd: oldGroup.isDnd || false,
				isTop: oldGroup.isTop || false,
				sdkCreated: true,
				allowAddFriend: groupExt.allowAddFriend !== false,
				isAllowInvite: Number(team.inviteMode) === 1,
				isAllowShareCard: groupExt.isAllowShareCard !== false,
				topMessage: groupExt.topMessage || oldGroup.topMessage || null
			};
		},
		loadFriendInfo(id) {
			let friend = this.friendStore.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					showNickName: "未知用户",
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.groupStore.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		},
		getHomeWindowSize() {
			let size = {
				width: HOME_WINDOW_DEFAULT_WIDTH,
				height: HOME_WINDOW_DEFAULT_HEIGHT
			};
			try {
				const savedSize = JSON.parse(localStorage.getItem(HOME_WINDOW_SIZE_KEY));
				if (savedSize && savedSize.width && savedSize.height) {
					size = savedSize;
				}
			} catch (e) {
				localStorage.removeItem(HOME_WINDOW_SIZE_KEY);
			}
			return {
				width: Math.max(Number(size.width) || HOME_WINDOW_DEFAULT_WIDTH, HOME_WINDOW_MIN_WIDTH),
				height: Math.max(Number(size.height) || HOME_WINDOW_DEFAULT_HEIGHT, HOME_WINDOW_MIN_HEIGHT)
			};
		},
		saveHomeWindowSize() {
			if (!window.electronAPI || this.configStore.fullScreen) return;
			localStorage.setItem(HOME_WINDOW_SIZE_KEY, JSON.stringify({
				width: Math.max(window.innerWidth, HOME_WINDOW_MIN_WIDTH),
				height: Math.max(window.innerHeight, HOME_WINDOW_MIN_HEIGHT)
			}));
		},
		onHomeWindowResize() {
			clearTimeout(this.windowResizeTimer);
			this.windowResizeTimer = setTimeout(() => {
				this.saveHomeWindowSize();
			}, 300);
		},
		showUserProfile() {
			this.$refs.userProfileCard.open();
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		mineAccount() {
			return this.mine.imAccid || this.mine.accountId || this.$yunxinIM.currentAccount || this.mine.id;
		},
		unreadCount() {
			let unreadCount = 0;
			let chats = this.chatStore.chats;
			chats.forEach((chat) => {
				if (!chat.delete && !chat.isDnd) {
					unreadCount += chat.unreadCount
				}
			});
			return unreadCount;
		},
		recvCount() {
			let requests = this.friendStore.requests;
			const friendCount = requests.filter((req) => this.isMineAccount(req.recvId)).length;
			const groupCount = this.groupStore.teamNotices.filter(notice => !notice.read).length;
			return friendCount + groupCount;
		}
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
			},
			immediate: true
		}
	},
	mounted() {
		this.init();
		const windowSize = this.getHomeWindowSize();
		// 修改electron窗口尺寸
		window.electronAPI && window.electronAPI.sendEvent('resize', {
			width: windowSize.width,
			height: windowSize.height,
			minWidth: HOME_WINDOW_MIN_WIDTH,
			minHeight: HOME_WINDOW_MIN_HEIGHT,
			maximizable: true
		})
		window.electronAPI && window.electronAPI.sendEvent('center')
		window.electronAPI && window.addEventListener('resize', this.onHomeWindowResize)
	},
	beforeDestroy() {
		clearTimeout(this.windowResizeTimer);
		window.removeEventListener('resize', this.onHomeWindowResize);
		this.clearYunxinEvents();
	},
	unmounted() {
		clearTimeout(this.windowResizeTimer);
		window.removeEventListener('resize', this.onHomeWindowResize);
		this.clearYunxinEvents();
	}
}
</script>

<style scoped lang="scss">
.home-page {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	overflow: hidden;
	background: var(--im-color-primary-light-9);

	.app-container {
		width: 62vw;
		height: 80vh;
		display: flex;
		min-height: 660px;
		min-width: 970px;
		position: absolute;
		border-radius: 4px;
		overflow: hidden;
		box-shadow: var(--im-box-shadow-dark);
		transition: 0.2s;

		&.electron {
			width: 100vw;
			height: 100vh;
		}

		&.fullscreen {
			transition: 0.2s;
			width: 100vw;
			height: 100vh;
		}
	}

	.navi-bar {
		--icon-font-size: 22px;
		--width: 70px;
		width: var(--width);
		background: linear-gradient(180deg, var(--im-color-primary-light-1) 0%, var(--im-color-primary-light-2) 100%);
		padding-top: 25px;
		position: relative;
		box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

		// 添加顶部装饰线
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 3px;
			background: linear-gradient(90deg, var(--im-color-primary) 0%, var(--im-color-primary-light-3) 50%, var(--im-color-primary) 100%);
		}

		.navi-bar-box {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.bottom {
				margin-bottom: 25px;
			}
		}

		.avater {
			display: flex;
			justify-content: center;
			margin-bottom: 10px;

			// 为头像添加容器样式
			:deep(.head-image) {
				border: 3px solid rgba(255, 255, 255, 0.2);
				border-radius: 50%;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				transition: all 0.3s ease;

				&:hover {
					border-color: rgba(255, 255, 255, 0.4);
					transform: scale(1.05);
					box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
				}
			}
		}

		.menu {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			flex-wrap: wrap;
			margin-top: 25px;
			gap: 8px;

			.link {
				text-decoration: none;
				display: flex;
				justify-content: center;
			}

			.router-link-active .menu-item {
				color: white;
				background: linear-gradient(135deg, var(--im-color-primary-light-2) 0%, var(--im-color-primary) 100%);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
				transform: translateX(2px);

				&::before {
					opacity: 1;
					transform: scale(1);
				}
			}

			.link:not(.router-link-active) .menu-item:hover {
				background: linear-gradient(135deg, var(--im-color-primary) 0%, var(--im-color-primary-light-2) 100%);
				transform: scale(1.08) translateX(2px);
				box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
				color: white;
			}

			.menu-item {
				position: relative;
				color: rgba(255, 255, 255, 0.8);
				width: 50px;
				height: 50px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 10px;
				border-radius: 12px;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				cursor: pointer;

				// 添加左侧指示条
				&::before {
					content: '';
					position: absolute;
					left: -5px;
					width: 3px;
					height: 20px;
					background: white;
					border-radius: 2px;
					opacity: 0;
					transition: all 0.3s ease;
				}

				.icon {
					font-size: var(--icon-font-size);
					transition: all 0.3s ease;
				}

				.unread-text {
					position: absolute;
					background: var(--im-color-danger);
					left: 32px;
					top: 3px;
					color: white;
					border-radius: 10px;
					padding: 1px 6px;
					font-size: 10px;
					font-weight: 600;
					text-align: center;
					white-space: nowrap;
					border: 1px solid rgba(255, 255, 255, 0.9);
					box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
					min-width: 16px;
					height: 16px;
					display: flex;
					align-items: center;
					justify-content: center;
					z-index: 1;
				}
			}
		}

		.bottom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 45px;
			width: 100%;
			cursor: pointer;
			color: rgba(255, 255, 255, 0.7);
			font-size: var(--icon-font-size);
			border-radius: 8px;
			margin: 4px 0;
			transition: all 0.3s ease;
			position: relative;

			.icon {
				font-size: var(--icon-font-size);
				transition: all 0.3s ease;
			}

			&:hover {
				color: white;
				background: rgba(255, 255, 255, 0.1);
				transform: scale(1.05);

				.icon {
					transform: scale(1.1);
				}
			}

			&:active {
				transform: scale(0.95);
			}
		}
	}

	.content-box {
		flex: 1;
		padding: 0;
		background: var(--im-background);
		text-align: center;
	}
}
</style>
